/**
 * Icon components used throughout the application, backed by react-icons.
 *
 * Usage:
 *   import { UserIcon, LockIcon, ... } from "../icons/Icons";
 */

import React from "react";
import {
  FiUser,
  FiLock,
  FiEye,
  FiEyeOff,
  FiArrowRight,
  FiArrowLeft,
  FiAlertCircle,
  FiCheck,
  FiGrid,
  FiUsers,
  FiUserPlus,
  FiTrash2,
  FiDollarSign,
  FiDownload,
  FiSearch,
  FiLogOut,
  FiCalendar,
  FiClock,
  FiMenu,
  FiSave,
  FiEdit2,
  FiX,
  FiArrowUpCircle,
  FiBookOpen,
  FiAward,
  FiBarChart2,
  FiHome,
  FiMail,
  FiPhone,
  FiMapPin,
} from "react-icons/fi";

// Existing icons
export const UserIcon = () => <FiUser className="input-icon" />;

export const LockIcon = () => <FiLock className="input-icon" />;

export const EyeIcon = () => <FiEye size={18} />;

export const EyeOffIcon = () => <FiEyeOff size={18} />;

export const ArrowIcon = () => <FiArrowRight size={18} />;

export const ArrowLeftIcon = () => <FiArrowLeft size={18} />;

export const AlertIcon = () => <FiAlertCircle size={16} />;

export const CheckIcon = () => <FiCheck size={28} />;

export const DashboardIcon = () => <FiGrid />;

export const StudentsIcon = () => <FiUsers />;

export const RegisterIcon = () => <FiUserPlus />;

export const DeleteIcon = () => <FiTrash2 />;

export const FeeIcon = () => <FiDollarSign />;

export const DownloadIcon = () => <FiDownload />;

export const SearchIcon = () => <FiSearch />;

export const LogoutIcon = () => <FiLogOut />;

export const CalendarIcon = () => <FiCalendar />;

export const ClockIcon = () => <FiClock />;

export const MenuIcon = () => <FiMenu size={22} />;

export const SaveIcon = () => <FiSave />;

export const UsersIcon = () => <FiUsers />;

export const EditIcon = () => <FiEdit2 />;

export const ViewIcon = () => <FiEye />;

export const CloseIcon = () => <FiX />;

export const PromoteIcon = () => <FiArrowUpCircle />;

// New Teacher Icons
export const GradeIcon = () => <FiAward size={18} />;

export const ReportIcon = () => <FiBarChart2 size={18} />;

export const CampusIcon = () => <FiHome size={18} />;

export const BookIcon = () => <FiBookOpen size={18} />;

export const MailIcon = () => <FiMail size={18} />;

export const PhoneIcon = () => <FiPhone size={18} />;

export const LocationIcon = () => <FiMapPin size={18} />;

export const XIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);